import { render } from "./dashboard.vue?vue&type=template&id=4ffb808d&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=4ffb808d&lang=css"
import "./dashboard.vue?vue&type=style&index=1&id=4ffb808d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffb808d"]])

export default __exports__